// import '@/@fake-db/db'
import { i18n } from '@/plugins/i18n'
import '@/styles/styles.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// import VCalendar from 'v-calendar'
import Vue from 'vue'

// import FunctionalCalendar from 'vue-functional-calendar'
import VueSignaturePad from 'vue-signature-pad'
import App from './App'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

// import infiniteScroll from 'vue-infinite-scroll'

// Vue.use(infiniteScroll)

// import { firebaseApp } from './firebase/index'
// import { firestorePlugin } from 'vuefire'

// Vue.use(firestorePlugin)

Vue.config.productionTip = false

// Vue.prototype.$bus = new Vue()
Vue.use(VueSignaturePad)

// Use v-calendar & v-date-picker components
// Vue.use(VCalendar, {
//   componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
// })

new Vue({
  router,
  store,
  i18n,
  vuetify,

  // firebaseApp,
  render: h => h(App),
}).$mount('#app')
